import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import MobileLayout from '../layouts/MobileLayout';
import MobilePromoWheel from '../components/MobilePromoWheel';

const MobilePromoWheelPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <MobileLayout>
      {/* Header avec bouton retour */}
      <div className="bg-white border-b border-gray-200 px-4 py-3">
        <div className="flex items-center space-x-3">
          <button
            onClick={() => navigate(-1)}
            className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
          >
            <ArrowLeft className="w-5 h-5 text-gray-600" />
          </button>
          <div>
            <h1 className="text-lg font-bold text-gray-900">Roue de Promotions</h1>
            <p className="text-xs text-gray-600">Tentez votre chance et gagnez des réductions!</p>
          </div>
        </div>
      </div>

      {/* Contenu principal */}
      <div className="min-h-screen bg-gradient-to-b from-blue-50/30 to-white">
        <MobilePromoWheel />
      </div>
    </MobileLayout>
  );
};

export default MobilePromoWheelPage;
